// extracted by mini-css-extract-plugin
module.exports = {"className":"textPromoTitleS_className__BhHzw"};